import { connect } from 'react-redux';
import { useAppDispatch } from '@wfp-root-app/store/store';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import React from 'react';
import { bindActionCreators, Dispatch, AnyAction } from 'redux';

import AppState from '../app/store/state';
import { EditBeneficiaryCreators } from './edit/editBeneficiaryActionCreator';
import ActivityLogsList from '../activityLogs/ActivityLogsList';
import { ActionCreators as ManagerActionCreators } from '../managers/managers';
import { ActionCreators as VendorActionCreators } from '../vendors/vendors';
import { ManagerPermission } from '../permission-profiles/permission';
import { ActionCreators as PartnerActionCreators } from '../partners/partnersActions';

function mapDispatchToProps(dispatch: Dispatch<AnyAction>) {
    return {
        loadManagersNickNames: bindActionCreators(ManagerActionCreators.loadManagersNickNames, dispatch),
        loadVendorsNickNames: bindActionCreators(VendorActionCreators.loadVendorsNickNames, dispatch),
        loadVendorUsersNames: bindActionCreators(VendorActionCreators.loadVendorUsersNames, dispatch),
        loadPartnersNames: bindActionCreators(PartnerActionCreators.loadPartnersNames, dispatch),
        loadPartnerUserNames: bindActionCreators(PartnerActionCreators.loadPartnerUsersName, dispatch),
        isManager: false,
    };
}

function mapStateToProps(state: AppState) {
    return {
        activityLogs: state.editBeneficiary.activityLogs,
        managersNickNames: state.managers.managerNickNameList,
        vendorsNickNames: state.vendors.nickNameList,
        vendorUsersNames: state.vendors.usersNames,
        url: '/beneficiaries/export-activity-log',
        auth: state.auth,
        downloadRestriction: [ManagerPermission.operationActivityDownload],
        partnersNickNames: state.partners.nameList,
        partnerUsersNickNames: state.partners.partnerUsersNamesList,
    };
}

const withHooks = (Component: any) => {
    // eslint-disable-next-line react/display-name
    return (props: any) => {
        const location = useLocation();
        const params = useParams();
        const navigate = useNavigate();
        const dispatch = useAppDispatch();

        return (
            <Component
                {...props}
                dispatch={dispatch}
                entityId={location.state?.beneficiaryId}
                loadActivityLogs={(page, limit) =>
                    dispatch(
                        EditBeneficiaryCreators.loadBeneficiaryActivityLogs(location.state?.beneficiaryId, page, limit)
                    )
                }
                location={location}
                navigate={navigate}
                params={params}
            />
        );
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withHooks(ActivityLogsList));
